import React from 'react';
import './Switch.css';

const Switch = ({ isOn, handleToggle, onColor, id = 'react-switch-new', disabled = false }) => {
    return (
        <>
            <input
                checked={isOn}
                onChange={disabled ? undefined : handleToggle}
                className="react-switch-checkbox"
                id={id}
                type="checkbox"
                disabled={disabled}
            />
            <label
                style={{ background: isOn && onColor, opacity: disabled ? 0.5 : 1, cursor: disabled ? 'not-allowed' : 'pointer' }}
                className="react-switch-label"
                htmlFor={id}
            >
                <span className={`react-switch-button`} />
            </label>
        </>
    );
};

export default Switch;